import React, { useCallback } from 'react'
import styles from './DialListSettings.module.css'
import { useTranslation } from "react-i18next";
import SettingsDropDown from '../../../UI/SettingsDropDown/SettingsDropDown'


const DialListSettings = (props) => {
    const [t] = useTranslation('common')
    const setSettings = props.setSettings
    const setSaveAndRestartBtnActiveState = props.setSaveAndRestartBtnActiveState

    const setSettingsMiddleware = useCallback((settingType, settingName, value) => {
        setSettings(settingType, settingName, value)
        setSaveAndRestartBtnActiveState(true)
    }, [setSettings, setSaveAndRestartBtnActiveState])

    const autoCloseDialistOnEndCallArray = [true, false]
    const enablePostponeToOtherAgentArray = [true, false]
    const enableChangeGetCallBacksStateOnBreakArray = [true, false]


    return (
        <section className={styles.SettingsSection}>
            <h2 className={styles.settingsTitle}>{t('dialListSettings')}</h2>
            <SettingsDropDown nowSelected={props.dialListSettings.autoCloseDialistOnEndCall} setSettings={setSettingsMiddleware} settingType={'dialList'} label={'autoCloseDialistOnEndCall'} settingName={'autoCloseDialistOnEndCall'} items={autoCloseDialistOnEndCallArray} />
            <SettingsDropDown nowSelected={props.dialListSettings.enablePostponeToOtherAgent} setSettings={setSettingsMiddleware} settingType={'dialList'} label={'enablePostponeToOtherAgent'} settingName={'enablePostponeToOtherAgent'} items={enablePostponeToOtherAgentArray} />
            <SettingsDropDown nowSelected={props.dialListSettings.enableChangeGetCallBacksStateOnBreak} setSettings={setSettingsMiddleware} settingType={'dialList'} label={'enableChangeGetCallBacksStateOnBreak'} settingName={'enableChangeGetCallBacksStateOnBreak'} items={enableChangeGetCallBacksStateOnBreakArray} />
        </section >
    )
}

export default DialListSettings;